module.exports = __webpack_public_path__ + "static/media/kurt.efae5d95.png";